import { render, staticRenderFns } from "./YRichText.vue?vue&type=template&id=2ad80d95&scoped=true"
import script from "./YRichText.vue?vue&type=script&lang=js"
export * from "./YRichText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad80d95",
  null
  
)

export default component.exports